import React, { useEffect } from 'react';

import { useTimer } from '../../context/TimerContext';

import { usePageControl } from '../../context/PageControlContext';
import PageNavigation from '../../components/PageNavigation';

import GuessPassword from '../../components/GuessPassword';

function Module3() {

  // Page nav control
  const { canContinue, setCanContinue } = usePageControl();

  useEffect(() => {
    setCanContinue(false);
  }, [setCanContinue]);

  const handleSuccess = () => {
    setCanContinue(true);
  };

  // Timer
  const { timeRemaining, formatTime, isRunning } = useTimer();

  // Determine additional classes dynamically
  let additionalClasses = '';
  if (isRunning) {
    additionalClasses += ' timer-running';
  }
  if (timeRemaining <= 600 && timeRemaining >= 0) { // 10 mins or less but not negative
    additionalClasses += ' timer-warning';
  }
  if (timeRemaining < 0) { // time exceeded
    additionalClasses += ' timer-exceeded';
  } 


  return (
    <div id="module-3" className="page physical">
        
        <header className="container-fluid">
            <div className="row">
                <div className="col-12">
                  <div id="CER"></div>
                  <div id="line"></div>
                  <div className={`timer-display${additionalClasses}`}>
                    <span className="timer-text">Time remaining <span className="timer-numbers">{formatTime(timeRemaining)}</span></span>
                  </div>
                </div>
            </div>
        </header>
    
        <main className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div id="box-wrapper-login">
                        <div id="box-wrapper-login-header"><h1>DCI Crooks' Password</h1></div>
                        <div id="box-wrapper-login-body">
                          <GuessPassword
                            hashedAnswer="e4ad93ca07acb8d908a3aa41e920ea4f4ef4f26e7f86cf8291c5db289780a5ae" // SHA-256 (lower cased)
                            onSuccess={handleSuccess}
                          >
                                <p>Enter password to log in</p>
                          </GuessPassword>
                        </div>
                    </div>
                </div>
            </div>
        </main>

        <footer className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <PageNavigation />
                </div>
            </div>
        </footer>
    
    </div>
  );
};

export default Module3;
